import { render, staticRenderFns } from "./SelectWithValidation.vue?vue&type=template&id=5bb2960f&lang=pug&"
import script from "./SelectWithValidation.vue?vue&type=script&lang=js&"
export * from "./SelectWithValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports